
        Component.define('modal-score', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el              = $(el);
const $openModal = $('[data-open-modal-score]');
const $btnCloseModal   = $el.find('.btn-close-modal');

$openModal.on('click', function(){
    $el.fadeIn(400);
    $el.addClass('modal-score-opened');
    $body.addClass('modal-opened');
});

$btnCloseModal.on("click", function() {
    $el.fadeOut(400);
    $el.removeClass('modal-score-opened');
    $body.removeClass('modal-opened');
});








        });